declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Record<string, string | undefined>;
  }
}

/** Client env from Caddy-templated `/runtime-env.js` (or `public/runtime-env.js` in dev). */
const getConfig = () => {
  const runtime =
    typeof window !== 'undefined' && window.__RUNTIME_CONFIG__ ? window.__RUNTIME_CONFIG__ : {};
  return {
    publicRuntimeConfig: runtime
  };
};

export default getConfig;
